module.exports = __webpack_public_path__ + "static/media/disco-marker.4f879f8f.svg";